let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e4Idr")).then(() => parcelRequire('2HMYZ'));